document.addEventListener('DOMContentLoaded', function() {
    const videos = document.querySelectorAll('.njamito-hero-media__video[data-source-src]');

    videos.forEach(video => {
        function loadVideo(videoElement) {
            const source = document.createElement('source');
            source.src = videoElement.dataset.sourceSrc;
            source.type = videoElement.dataset.sourceType;
            videoElement.appendChild(source);
            videoElement.load();
            videoElement.play().catch(err => {
                console.log("Autoplay failed:", err);
            });
        }

        const style = window.getComputedStyle(video);
        if (style.display !== 'none' && video.querySelector('source') === null) {
            loadVideo(video);
        }

        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && entry.target.querySelector('source') === null) {
                    loadVideo(entry.target);
                    obs.unobserve(entry.target); // Stop observing after load
                }
            });
        }, {
            threshold: 0.1 // Trigger when at least 10% of the video is visible
        });

        observer.observe(video);
    });
});